module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/performance-green.93449f63.svg";